import { BodyBasedExpression } from '../Expression.js';
export class AppendExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        const body = this.getBody() ? this.getBody()
            .evaluate(visitor, localVariables) : undefined;
        if (Array.isArray(source) && !!body) {
            source.push(body);
        }
        return source;
    }
}
//# sourceMappingURL=AppendExpression.js.map